export const withBuyerHost = (path: string | null | undefined, buyerHost?: string): string => {
    if (path === null || path === undefined) {
        return '';
    }
    if (!buyerHost || path.startsWith('http')) {
        return path;
    }
    return `${buyerHost}${path}`;
};
